<template>
  <div>
    <base-toolbar :title="$t('CREATE_NEW_CARD')">
      <v-spacer></v-spacer>
      <v-btn icon color="primary" @click="handlePreviewClick">
        <v-icon>{{ mdiCheck }}</v-icon>
      </v-btn>
    </base-toolbar>

    <v-container fluid class="pt-0">
      <v-row justify="center" class="border-b d-none d-sm-flex">
        <v-col cols="12" md="8">
          <v-row dense align="center">
            <v-col cols="12" md="9" class="text-h6">
              {{ $t("FILL_ALL_DETAILS_GET_YOUR_CARD") }}
            </v-col>
            <v-col cols="12" md="3" class="large-screen">
              <v-btn
                class="px-5"
                rounded
                color="primary float-right"
                dark
                block
                style="min-width: 228px !important"
                :loading="$store.state.page_loader"
                @click="handlePreviewClick"
              >
                {{ $t("PREVIEW_CARD") }}
              </v-btn>
            </v-col>
          </v-row>
        </v-col>
      </v-row>

      <v-row justify="center">
        <v-col cols="12" md="8">
          <v-row dense>
            <v-col class="font-weight-bold">{{ $t("MAKING_CARD_FOR") }}</v-col>
          </v-row>
          <v-radio-group
            v-model="card_for"
            hide-details
            row
            dense
            @change="handleCheckbox"
          >
            <v-radio
              label="Bride's Side"
              value="bride"
              :class="{ active: bride_form }"
            ></v-radio>
            <v-radio
              label="Groom's Side"
              value="groom"
              :class="{ active: !bride_form }"
            ></v-radio>
          </v-radio-group>
          <v-form ref="add_detail_form" lazy-validation>
            <v-row no-gutters justify="center">
              <v-col cols="12" md="6">
                <GroomDetailsForm
                  v-if="!bride_form"
                  :groom_details="groom_details"
                  :template_details="template_details"
                ></GroomDetailsForm>
                <BrideDetailsForm
                  v-if="bride_form"
                  :bride_details="bride_details"
                  :template_details="template_details"
                ></BrideDetailsForm>
              </v-col>
              <v-col cols="12" md="6" class="pl-md-3">
                <GroomDetailsForm
                  v-if="bride_form"
                  :groom_details="groom_details"
                  :template_details="template_details"
                ></GroomDetailsForm>
                <BrideDetailsForm
                  v-if="!bride_form"
                  :bride_details="bride_details"
                  :template_details="template_details"
                ></BrideDetailsForm>
              </v-col>
            </v-row>
          </v-form>
          <v-row>
            <v-col>
              <FunctionDetailsForm
                :function-list="function_list"
                :template-details="template_details"
              >
              </FunctionDetailsForm>
            </v-col>
          </v-row>

          <v-row no-gutters>
            <v-col md="6">
              <OtherDetailsForm
                :other_details="other_details"
                :template_details="template_details"
                :is_edit="is_edit"
              ></OtherDetailsForm>
            </v-col>
          </v-row>
        </v-col>
      </v-row>

      <v-row justify="center" class="border-t pt-5 large-screen">
        <v-col cols="12" md="8" class="pt-0">
          <v-row align="end">
            <v-col cols="6" md="9" class="py-2">
              <span>
                {{ $t("NEED_HELP") }}
              </span>
              <span class="primary--text underline pl-1">
                <a :href="`tel:${support_contact}`">
                  <b>{{ support_contact }}</b>
                </a>
              </span>
            </v-col>
            <v-col cols="6" md="3" class="text-right px-0 py-2">
              <v-btn
                class="px-5"
                color="primary float-right"
                rounded
                block
                dark
                style="min-width: 228px !important"
                :loading="$store.state.page_loader"
                @click="handlePreviewClick"
              >
                {{ $t("PREVIEW_CARD") }}
              </v-btn>
            </v-col>
          </v-row>
        </v-col>
      </v-row>

      <v-row justify="center" class="border-t pt-5 small-screen">
        <v-col cols="12" md="8" class="pt-0">
          <v-row align="center">
            <v-col
              cols="12"
              md="3"
              class="text-center justify-center px-0 py-2"
            >
              <v-btn
                class="px-5"
                width="220px"
                color="primary"
                rounded
                dark
                height=""
                :loading="$store.state.page_loader"
                @click="handlePreviewClick"
              >
                {{ $t("PREVIEW_CARD") }}
              </v-btn>
            </v-col>

            <v-col cols="12" md="9" class="py-2 text-center">
              <span>
                {{ $t("NEED_HELP") }}
              </span>
              <span class="primary--text underline pl-1">
                <a :href="`tel:${support_contact}`">
                  <b>{{ support_contact }}</b>
                </a>
              </span>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import keys from "@/app-js/keys.js";
import urls from "@/app-js/urls.js";
import { mapGetters } from "vuex";
import { mdiCheck } from "@mdi/js";
import BrideDetailsForm from "@/components/forms/BrideDetailsForm.vue";
import GroomDetailsForm from "@/components/forms/GroomDetailsForm.vue";
import FunctionDetailsForm from "@/components/forms/FunctionDetailsForm.vue";
import OtherDetailsForm from "@/components/forms/OtherDetailsForm.vue";
import { mapState } from "vuex";

export default {
  components: {
    BrideDetailsForm,
    GroomDetailsForm,
    FunctionDetailsForm,
    OtherDetailsForm,
    BaseToolbar: () => import("@/components/BaseToolbar")
  },

  metaInfo: {
    title: "Create New Card"
  },

  data() {
    return {
      mdiCheck,
      is_edit: false,
      /* this is used for  already created  card id is used for */
      card_table_id: null,
      template_id: "",
      html_link: "",
      card_for: keys.BRIDE_SIDE,
      bride_form: true,
      bride_details: {
        first_name: "",
        last_name: "",
        fathers_name: "",
        mothers_name: "",
        grand_fathers_name: "",
        grand_mothers_name: ""
      },
      groom_details: {
        first_name: "",
        last_name: "",
        fathers_name: "",
        mothers_name: "",
        grand_fathers_name: "",
        grand_mothers_name: ""
      },
      template_details: {
        multiple_function_support: "",
        max_function_limit: "",
        parents_support: ""
      },
      function_list: [{ name: "", venue: "", date: null, time: null }],
      other_details: {
        special_message: "",
        special_message2: "",
        invitation_from: "",
        main_venue: "",
        main_date: null
      }
    };
  },

  computed: {
    ...mapGetters({
      user_email: "auth/getUserEmail",
      user_mobile: "auth/getUserMobile"
    }),
    ...mapState(["support_contact"])
  },

  prefetch() {
    this.logFirebaseEvent("create_new_card_open");
    this.template_id = "";
    this.card_table_id = null;
    this.is_edit = false;
    this.template_details = {
      multiple_function_support: "",
      max_function_limit: "",
      parents_support: ""
    };
    this.bride_details = {
      first_name: "",
      last_name: "",
      fathers_name: "",
      mothers_name: "",
      grand_fathers_name: "",
      grand_mothers_name: ""
    };
    this.groom_details = {
      first_name: "",
      last_name: "",
      fathers_name: "",
      mothers_name: "",
      grand_fathers_name: "",
      grand_mothers_name: ""
    };
    this.function_list = [{ name: "", venue: "", date: null, time: null }];
    this.card_for = keys.BRIDE_SIDE;
    this.other_details = {
      special_message: "",
      special_message2: "",
      invitation_from: "",
      main_venue: "",
      main_date: null
    };

    if (this.$route.name == "createCard" && this.$route.params.template_id) {
      this.template_id = this.$route.params.template_id;
      return this.fetchTemplateDetails();
    } else if (this.$route.name == "editCard" && this.$route.params.card_id) {
      this.card_table_id = this.$route.params.card_id;
      this.is_edit = true;
      return this.fetchCardDetails();
    }
  },

  mounted() {
    this.autofillForm();
  },

  methods: {
    autofillForm() {
      let card_detail = JSON.parse(localStorage.getItem("user_card_detail"));
      if (Boolean(card_detail) != false) {
        this.bride_details = card_detail.bride_details;
        this.card_for = card_detail.card_for;
        this.groom_details = card_detail.groom_details;
        this.other_details = card_detail.other_details;
        this.function_list = card_detail.function_list;
      }
    },

    handleCheckbox(val) {
      this.bride_form = val == "bride";
    },

    async handlePreviewClick() {
      if (!this.$refs.add_detail_form.validate()) {
        return;
      }

      this.logFirebaseEvent("create_new_card_submit");

      if (!(this.user_email || this.user_mobile)) {
        this.$store.dispatch("setLoginDialog", true);
        await new Promise(resolve => {
          const unwatch = this.$store.watch(
            state => state.auth.profile,
            profile => {
              if (profile) {
                unwatch();
                resolve();
              }
            }
          );
        });
      }

      if (this.card_table_id) await this.editCard();
      else await this.createCard();
    },

    async fetchTemplateDetails() {
      const params = {
        template_id: this.template_id,
        lang: this.$store.state.language
      };
      const response = await this.$axios.get(urls.SUGGEST_CARD, { params });
      this.template_details = response.data.suggestions;
    },

    async fetchCardDetails() {
      const params = {
        card_table_id: this.card_table_id
      };
      const response = await this.$axios.get(urls.GET_CARD, { params });
      this.card_for = response.data.wedding_card.card_for;
      this.template_details = response.data.wedding_card.template_details;
      this.bride_details = response.data.wedding_card.bride_details;
      this.groom_details = response.data.wedding_card.groom_details;
      this.function_list = response.data.wedding_card.function_list;
      this.card_for = response.data.wedding_card.card_for;
      this.other_details = response.data.wedding_card.other_details;
    },

    async createCard() {
      const url = urls.CREATE_CARD;
      const form = new FormData();
      form.append("template_id", this.template_id);
      form.append("card_for", this.card_for);
      form.append("lang", this.$store.state.language);
      form.append("bride_details", JSON.stringify(this.bride_details));
      form.append("groom_details", JSON.stringify(this.groom_details));
      form.append("other_details", JSON.stringify(this.other_details));
      form.append("function_list", JSON.stringify(this.function_list));
      const response = await this.$axios.post(url, form);
      this.card_table_id = response.data.card_table_id;
      this.html_link = response.data.html_link;

      const card_detail = {
        bride_details: this.bride_details,
        card_for: this.card_for,
        groom_details: this.groom_details,
        other_details: this.other_details,
        function_list: this.function_list
      };
      localStorage.setItem("user_card_detail", JSON.stringify(card_detail));

      this.$router.push({
        name: "previewCard",
        params: { card_id: response.data.card_table_id }
      });
    },

    async editCard() {
      const url = urls.EDIT_CARD;
      const form = new FormData();
      form.append("template_id", this.template_details.id);
      form.append("card_table_id", this.card_table_id);
      form.append("card_for", this.card_for);
      form.append("lang", this.$store.state.language);
      form.append("bride_details", JSON.stringify(this.bride_details));
      form.append("groom_details", JSON.stringify(this.groom_details));
      form.append("other_details", JSON.stringify(this.other_details));
      form.append("function_list", JSON.stringify(this.function_list));

      await this.$axios.post(url, form);

      this.$router.push({
        name: "previewCard",
        params: { card_id: this.card_table_id }
      });
    }
  }
};
</script>

<style scoped>
.active .v-label {
  color: black;
}
</style>
